import { Outlet } from 'react-router-dom';
import { Box, Paper, useTheme } from '@mui/material';
import { useState } from 'react';

export const AppLayout = () => {
  const theme = useTheme();

  return (
    <Box
      id="pos-app-root"
      sx={{
        display: 'flex',
        height: '100vh',
        width: '100%',
        flexDirection: 'row',
        background:
          'linear-gradient(90deg, #F4F2F4 28.04%, #E7E9FE 65.89%, #F3F7FF 91.6%)',
      }}
    >
      <Box
        component={Paper}
        sx={{
          flexGrow: 1,
          height: '100%',
          width: '100%',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#FFFFFF',
          borderRadius: theme.unit(2),
          boxShadow: theme.shadows[1],
          border: `1px solid #7676801F`,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppLayout;
